/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * organization-management-business
 * organization-management-business-api
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as Url from 'url'

const url = Url as any
url.URLSearchParams = URLSearchParams

/**
 *
 *@export
 *@interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
  abort: () => void
}

/**
 *
 *@export
 *@class RequiredError
 *@extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError"

  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 * 
 * @export
 * @interface AccessPolicyResponse
 */
export interface AccessPolicyResponse {
    /**
     * 前端给的菜单唯一标识
     * @type {string}
     * @memberof AccessPolicyResponse
     */
    menu_unique_key?: string;
    /**
     * 支持read、write、delete、read_null、write_null、delete_null，例如：read+write+delete,表示拥有读、写、删权限，read_null代表读分组无接口
     * @type {string}
     * @memberof AccessPolicyResponse
     */
    permission_code?: string;
}

/**
 * 
 * @export
 * @interface ActivationResult
 */
export interface ActivationResult {
    /**
     * 
     * @type {boolean}
     * @memberof ActivationResult
     */
    is_activated?: boolean;
}

/**
 * 
 * @export
 * @interface AnnouncementResponse
 */
export interface AnnouncementResponse {
    /**
     * content
     * @type {string}
     * @memberof AnnouncementResponse
     */
    content: string;
    /**
     * publisher
     * @type {string}
     * @memberof AnnouncementResponse
     */
    publisher: string;
    /**
     * Announcement release time
     * @type {number}
     * @memberof AnnouncementResponse
     */
    publisher_time_at: number;
    /**
     * title
     * @type {string}
     * @memberof AnnouncementResponse
     */
    title: string;
}

/**
 * 
 * @export
 * @interface BlockStrategiesResponse
 */
export interface BlockStrategiesResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof BlockStrategiesResponse
     */
    block_strategies?: Array<number>;
}

/**
 * 
 * @export
 * @interface BusinessUserOpenApiSecretKeyCreateRequest
 */
export interface BusinessUserOpenApiSecretKeyCreateRequest {
    /**
     * business open api secret key name
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateRequest
     */
    name: string;
    /**
     * verification code
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateRequest
     */
    verification_code: string;
}

/**
 * 
 * @export
 * @interface BusinessUserOpenApiSecretKeyCreateResponse
 */
export interface BusinessUserOpenApiSecretKeyCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateResponse
     */
    app_key?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateResponse
     */
    app_secret?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyCreateResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface BusinessUserOpenApiSecretKeyDeleteRequest
 */
export interface BusinessUserOpenApiSecretKeyDeleteRequest {
    /**
     * verification code
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyDeleteRequest
     */
    verification_code: string;
}

/**
 * 
 * @export
 * @interface BusinessUserOpenApiSecretKeyResponse
 */
export interface BusinessUserOpenApiSecretKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    app_key: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    app_secret_ciphertext: string;
    /**
     * 
     * @type {number}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    created_at: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyResponse
     */
    status: BusinessUserOpenApiSecretKeyResponse.StatusEnum;
}

/**
 * @export
 * @namespace BusinessUserOpenApiSecretKeyResponse
 */
export namespace BusinessUserOpenApiSecretKeyResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface BusinessUserOpenApiSecretKeyUpdateStatusRequest
 */
export interface BusinessUserOpenApiSecretKeyUpdateStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyUpdateStatusRequest
     */
    status: BusinessUserOpenApiSecretKeyUpdateStatusRequest.StatusEnum;
    /**
     * verification code
     * @type {string}
     * @memberof BusinessUserOpenApiSecretKeyUpdateStatusRequest
     */
    verification_code: string;
}

/**
 * @export
 * @namespace BusinessUserOpenApiSecretKeyUpdateStatusRequest
 */
export namespace BusinessUserOpenApiSecretKeyUpdateStatusRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface CDNDomainBindingInfoRequest
 */
export interface CDNDomainBindingInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoRequest
     */
    domain_binding_record_type: CDNDomainBindingInfoRequest.DomainBindingRecordTypeEnum;
}

/**
 * @export
 * @namespace CDNDomainBindingInfoRequest
 */
export namespace CDNDomainBindingInfoRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum DomainBindingRecordTypeEnum {
        TXT = <any> 'TXT',
        CNAME = <any> 'CNAME'
    }
}

/**
 * 
 * @export
 * @interface CDNDomainBindingInfoResponse
 */
export interface CDNDomainBindingInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoResponse
     */
    record?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoResponse
     */
    record_full_text?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoResponse
     */
    record_type?: CDNDomainBindingInfoResponse.RecordTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingInfoResponse
     */
    record_value?: string;
}

/**
 * @export
 * @namespace CDNDomainBindingInfoResponse
 */
export namespace CDNDomainBindingInfoResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum RecordTypeEnum {
        TXT = <any> 'TXT',
        CNAME = <any> 'CNAME'
    }
}

/**
 * 
 * @export
 * @interface CDNDomainBindingVerificationRequest
 */
export interface CDNDomainBindingVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingVerificationRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainBindingVerificationRequest
     */
    domain_binding_record_type: CDNDomainBindingVerificationRequest.DomainBindingRecordTypeEnum;
}

/**
 * @export
 * @namespace CDNDomainBindingVerificationRequest
 */
export namespace CDNDomainBindingVerificationRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum DomainBindingRecordTypeEnum {
        TXT = <any> 'TXT',
        CNAME = <any> 'CNAME'
    }
}

/**
 * 
 * @export
 * @interface CDNDomainSSLCertificateInfoRequest
 */
export interface CDNDomainSSLCertificateInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CDNDomainSSLCertificateInfoRequest
     */
    cert: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainSSLCertificateInfoRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof CDNDomainSSLCertificateInfoRequest
     */
    key: string;
}

/**
 * 
 * @export
 * @interface CDNSettingResponse
 */
export interface CDNSettingResponse {
    /**
     * 
     * @type {CDNStatusResponse}
     * @memberof CDNSettingResponse
     */
    cdn_status?: CDNStatusResponse;
    /**
     * 
     * @type {string}
     * @memberof CDNSettingResponse
     */
    domain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CDNSettingResponse
     */
    domain_cname_bound?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CDNSettingResponse
     */
    domain_cname_bound_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CDNSettingResponse
     */
    domain_owner_verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CDNSettingResponse
     */
    domain_owner_verified_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CDNSettingResponse
     */
    https_cert_uploaded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CDNSettingResponse
     */
    https_cert_uploaded_at?: string;
}

/**
 * 
 * @export
 * @interface CDNStatusResponse
 */
export interface CDNStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CDNStatusResponse
     */
    cdn_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    cert_expire_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    cert_life?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    cert_status?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    cname_status?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    domain_status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CDNStatusResponse
     */
    is_https?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CDNStatusResponse
     */
    latest_detected_at?: string;
}

/**
 * 
 * @export
 * @interface ChangeSuperAdminRequest
 */
export interface ChangeSuperAdminRequest {
    /**
     * Verification Code
     * @type {string}
     * @memberof ChangeSuperAdminRequest
     */
    code: string;
    /**
     * new admin
     * @type {string}
     * @memberof ChangeSuperAdminRequest
     */
    new_admin_email: string;
    /**
     * new role
     * @type {string}
     * @memberof ChangeSuperAdminRequest
     */
    new_role_id: string;
}

/**
 * 
 * @export
 * @interface CheckSuperAdminEmailResponse
 */
export interface CheckSuperAdminEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckSuperAdminEmailResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSuperAdminEmailResponse
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSuperAdminEmailResponse
     */
    role_name?: string;
}

/**
 * 
 * @export
 * @interface CommonBooleanResponse
 */
export interface CommonBooleanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommonBooleanResponse
     */
    is_success?: boolean;
}

/**
 * 
 * @export
 * @interface DwSyncApiVersionResponse
 */
export interface DwSyncApiVersionResponse {
    /**
     * 版本ID
     * @type {string}
     * @memberof DwSyncApiVersionResponse
     */
    version_id?: string;
    /**
     * 版本显示名称
     * @type {string}
     * @memberof DwSyncApiVersionResponse
     */
    version_name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncBaseConfigEditRequest
 */
export interface DwSyncBaseConfigEditRequest {
    /**
     * api版本
     * @type {string}
     * @memberof DwSyncBaseConfigEditRequest
     */
    api_version: string;
    /**
     * clientId
     * @type {string}
     * @memberof DwSyncBaseConfigEditRequest
     */
    client_id: string;
    /**
     * clientPass
     * @type {string}
     * @memberof DwSyncBaseConfigEditRequest
     */
    client_pass?: string;
    /**
     * 主机名
     * @type {string}
     * @memberof DwSyncBaseConfigEditRequest
     */
    hostname: string;
}

/**
 * 
 * @export
 * @interface DwSyncBaseConfigResponse
 */
export interface DwSyncBaseConfigResponse {
    /**
     * api版本
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    api_version?: string;
    /**
     * clientId
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    client_id?: string;
    /**
     * clientPass
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    client_pass?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    created_at?: string;
    /**
     * 修改人
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    created_by?: string;
    /**
     * 修改人ID
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    created_by_user_id?: string;
    /**
     * 是否删除
     * @type {boolean}
     * @memberof DwSyncBaseConfigResponse
     */
    deleted?: boolean;
    /**
     * 主机名
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    hostname?: string;
    /**
     * ID
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    id?: string;
    /**
     * 配置状态
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    status?: DwSyncBaseConfigResponse.StatusEnum;
    /**
     * 修改时间
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    updated_at?: string;
    /**
     * 创建人
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    updated_by?: string;
    /**
     * 创建人ID
     * @type {string}
     * @memberof DwSyncBaseConfigResponse
     */
    updated_by_user_id?: string;
}

/**
 * @export
 * @namespace DwSyncBaseConfigResponse
 */
export namespace DwSyncBaseConfigResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        SUCCESS = <any> 'SUCCESS',
        HOSTNAMEINVALID = <any> 'HOSTNAME_INVALID',
        APIVERSIONINVALID = <any> 'API_VERSION_INVALID',
        CLIENTIDINVALID = <any> 'CLIENT_ID_INVALID',
        CLIENTPASSINVALID = <any> 'CLIENT_PASS_INVALID',
        CLIENTAUTHERROR = <any> 'CLIENT_AUTH_ERROR',
        PERMISSIONDENIED = <any> 'PERMISSION_DENIED',
        OTHERSERROR = <any> 'OTHERS_ERROR'
    }
}

/**
 * 
 * @export
 * @interface DwSyncCatalogResponse
 */
export interface DwSyncCatalogResponse {
    /**
     * 绑定的Site
     * @type {Array<string>}
     * @memberof DwSyncCatalogResponse
     */
    assigned_sites?: Array<string>;
    /**
     * 目录ID
     * @type {string}
     * @memberof DwSyncCatalogResponse
     */
    id?: string;
    /**
     * 目录名称
     * @type {string}
     * @memberof DwSyncCatalogResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncInventoryListResponse
 */
export interface DwSyncInventoryListResponse {
    /**
     * 绑定的Site
     * @type {Array<string>}
     * @memberof DwSyncInventoryListResponse
     */
    assigned_sites?: Array<string>;
    /**
     * 价目表描述
     * @type {string}
     * @memberof DwSyncInventoryListResponse
     */
    description?: string;
    /**
     * 价目表ID
     * @type {string}
     * @memberof DwSyncInventoryListResponse
     */
    id?: string;
    /**
     * 价目表名称
     * @type {string}
     * @memberof DwSyncInventoryListResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncLocaleResponse
 */
export interface DwSyncLocaleResponse {
    /**
     * 语言ID
     * @type {string}
     * @memberof DwSyncLocaleResponse
     */
    id?: string;
    /**
     * 语言名称
     * @type {string}
     * @memberof DwSyncLocaleResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncSiteDetailResponse
 */
export interface DwSyncSiteDetailResponse {
    /**
     * 默认货币
     * @type {string}
     * @memberof DwSyncSiteDetailResponse
     */
    currency?: string;
    /**
     * 站点ID
     * @type {string}
     * @memberof DwSyncSiteDetailResponse
     */
    id?: string;
    /**
     * 站点名称
     * @type {string}
     * @memberof DwSyncSiteDetailResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncSiteResponse
 */
export interface DwSyncSiteResponse {
    /**
     * 站点ID
     * @type {string}
     * @memberof DwSyncSiteResponse
     */
    id?: string;
    /**
     * 站点名称
     * @type {string}
     * @memberof DwSyncSiteResponse
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface DwSyncTaskColumnMappingRequest
 */
export interface DwSyncTaskColumnMappingRequest {
    /**
     * 来源字段
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    source_column_key?: string;
    /**
     * 来源字段名
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    source_column_name?: string;
    /**
     * 来源字段类型
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    source_type?: DwSyncTaskColumnMappingRequest.SourceTypeEnum;
    /**
     * 目标字段
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    target_column_key?: string;
    /**
     * 目标字段名
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    target_column_name?: string;
    /**
     * 目标字段类型
     * @type {string}
     * @memberof DwSyncTaskColumnMappingRequest
     */
    target_type?: DwSyncTaskColumnMappingRequest.TargetTypeEnum;
}

/**
 * @export
 * @namespace DwSyncTaskColumnMappingRequest
 */
export namespace DwSyncTaskColumnMappingRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        CUSTOMCATEGORY = <any> 'CUSTOM_CATEGORY',
        CUSTOMPRODUCT = <any> 'CUSTOM_PRODUCT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TargetTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        SKU = <any> 'SKU',
        ATTRIBUTE = <any> 'ATTRIBUTE',
        VARIATIONATTRIBUTE = <any> 'VARIATION_ATTRIBUTE',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER',
        CUSTOM = <any> 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskColumnMappingResponse
 */
export interface DwSyncTaskColumnMappingResponse {
    /**
     * 来源字段
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    source_column_key?: string;
    /**
     * 来源字段名
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    source_column_name?: string;
    /**
     * 来源字段类型
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    source_type?: DwSyncTaskColumnMappingResponse.SourceTypeEnum;
    /**
     * 目标字段
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    target_column_key?: string;
    /**
     * 目标字段名
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    target_column_name?: string;
    /**
     * 目标字段类型
     * @type {string}
     * @memberof DwSyncTaskColumnMappingResponse
     */
    target_type?: DwSyncTaskColumnMappingResponse.TargetTypeEnum;
}

/**
 * @export
 * @namespace DwSyncTaskColumnMappingResponse
 */
export namespace DwSyncTaskColumnMappingResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum SourceTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        CUSTOMCATEGORY = <any> 'CUSTOM_CATEGORY',
        CUSTOMPRODUCT = <any> 'CUSTOM_PRODUCT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TargetTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        SKU = <any> 'SKU',
        ATTRIBUTE = <any> 'ATTRIBUTE',
        VARIATIONATTRIBUTE = <any> 'VARIATION_ATTRIBUTE',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER',
        CUSTOM = <any> 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskDetailResponse
 */
export interface DwSyncTaskDetailResponse {
    /**
     * 创建时间
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    created_at?: string;
    /**
     * 修改人
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    created_by?: string;
    /**
     * 修改人ID
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    created_by_user_id?: string;
    /**
     * 是否删除
     * @type {boolean}
     * @memberof DwSyncTaskDetailResponse
     */
    deleted?: boolean;
    /**
     * 描述
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    description?: string;
    /**
     * ID
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    id?: string;
    /**
     * 最后一次调度任务运行结束时间
     * @type {number}
     * @memberof DwSyncTaskDetailResponse
     */
    last_stop_at?: number;
    /**
     * 商品同步配置详情
     * @type {DwSyncTaskProductDetailResponse}
     * @memberof DwSyncTaskDetailResponse
     */
    product_detail?: DwSyncTaskProductDetailResponse;
    /**
     * 调度结束时间
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    schedule_end_at?: string;
    /**
     * 调度执行间隔
     * @type {number}
     * @memberof DwSyncTaskDetailResponse
     */
    schedule_interval?: number;
    /**
     * 调度开始时间
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    schedule_start_at?: string;
    /**
     * 调度类型
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    schedule_type?: DwSyncTaskDetailResponse.ScheduleTypeEnum;
    /**
     * 任务状态
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    status?: DwSyncTaskDetailResponse.StatusEnum;
    /**
     * 任务名
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    task_name?: string;
    /**
     * 任务类型
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    task_type?: DwSyncTaskDetailResponse.TaskTypeEnum;
    /**
     * 修改时间
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    updated_at?: string;
    /**
     * 创建人
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    updated_by?: string;
    /**
     * 创建人ID
     * @type {string}
     * @memberof DwSyncTaskDetailResponse
     */
    updated_by_user_id?: string;
}

/**
 * @export
 * @namespace DwSyncTaskDetailResponse
 */
export namespace DwSyncTaskDetailResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ScheduleTypeEnum {
        ONETIME = <any> 'ONE_TIME',
        ONGOING = <any> 'ON_GOING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED',
        DISABLING = <any> 'DISABLING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TaskTypeEnum {
        PRODUCT = <any> 'PRODUCT',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskEditRequest
 */
export interface DwSyncTaskEditRequest {
    /**
     * 描述
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    description?: string;
    /**
     * 商品同步配置详情
     * @type {DwSyncTaskProductDetailEditRequest}
     * @memberof DwSyncTaskEditRequest
     */
    product_detail?: DwSyncTaskProductDetailEditRequest;
    /**
     * 调度结束时间
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    schedule_end_at?: string;
    /**
     * 调度执行间隔
     * @type {number}
     * @memberof DwSyncTaskEditRequest
     */
    schedule_interval?: number;
    /**
     * 调度开始时间
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    schedule_start_at?: string;
    /**
     * 调度类型
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    schedule_type?: DwSyncTaskEditRequest.ScheduleTypeEnum;
    /**
     * 任务状态
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    status?: DwSyncTaskEditRequest.StatusEnum;
    /**
     * 任务名
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    task_name?: string;
    /**
     * 任务类型
     * @type {string}
     * @memberof DwSyncTaskEditRequest
     */
    task_type?: DwSyncTaskEditRequest.TaskTypeEnum;
}

/**
 * @export
 * @namespace DwSyncTaskEditRequest
 */
export namespace DwSyncTaskEditRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ScheduleTypeEnum {
        ONETIME = <any> 'ONE_TIME',
        ONGOING = <any> 'ON_GOING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED',
        DISABLING = <any> 'DISABLING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TaskTypeEnum {
        PRODUCT = <any> 'PRODUCT',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskJobResponse
 */
export interface DwSyncTaskJobResponse {
    /**
     * 创建时间
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    created_at?: string;
    /**
     * 是否删除
     * @type {boolean}
     * @memberof DwSyncTaskJobResponse
     */
    deleted?: boolean;
    /**
     * 同步异常的元素个数
     * @type {number}
     * @memberof DwSyncTaskJobResponse
     */
    error_count?: number;
    /**
     * ID
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    id?: string;
    /**
     * 任务执行开始时间
     * @type {number}
     * @memberof DwSyncTaskJobResponse
     */
    job_start_at?: number;
    /**
     * 任务执行开始时间
     * @type {number}
     * @memberof DwSyncTaskJobResponse
     */
    job_stop_at?: number;
    /**
     * 任务执行停止类型,1成功且无异常,2失败,3成功但有异常,4用户中断,5服务中断
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    job_stop_type?: DwSyncTaskJobResponse.JobStopTypeEnum;
    /**
     * 报告下载链接
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    report_url?: string;
    /**
     * 同步成功的元素个数
     * @type {number}
     * @memberof DwSyncTaskJobResponse
     */
    success_count?: number;
    /**
     * 任务ID
     * @type {number}
     * @memberof DwSyncTaskJobResponse
     */
    task_id?: number;
    /**
     * 任务类型
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    task_type?: DwSyncTaskJobResponse.TaskTypeEnum;
    /**
     * 修改时间
     * @type {string}
     * @memberof DwSyncTaskJobResponse
     */
    updated_at?: string;
}

/**
 * @export
 * @namespace DwSyncTaskJobResponse
 */
export namespace DwSyncTaskJobResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum JobStopTypeEnum {
        SUCCESS = <any> 'SUCCESS',
        FAIL = <any> 'FAIL',
        SUCCESSWITHERROR = <any> 'SUCCESS_WITH_ERROR',
        USERINTERRUPT = <any> 'USER_INTERRUPT',
        SERVICEINTERRUPT = <any> 'SERVICE_INTERRUPT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TaskTypeEnum {
        PRODUCT = <any> 'PRODUCT',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskProductDetailEditRequest
 */
export interface DwSyncTaskProductDetailEditRequest {
    /**
     * 目录ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    catalog_id?: string;
    /**
     * 映射列表
     * @type {Array<DwSyncTaskColumnMappingRequest>}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    column_mapping_list?: Array<DwSyncTaskColumnMappingRequest>;
    /**
     * 货币
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    currency?: string;
    /**
     * 图片根目录
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    image_root?: string;
    /**
     * 库存单ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    inventory_list_id?: string;
    /**
     * 区域语言
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    locale?: string;
    /**
     * 站点ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    site_id?: string;
    /**
     * 分辨率
     * @type {string}
     * @memberof DwSyncTaskProductDetailEditRequest
     */
    view_type?: string;
}

/**
 * 
 * @export
 * @interface DwSyncTaskProductDetailResponse
 */
export interface DwSyncTaskProductDetailResponse {
    /**
     * 目录ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    catalog_id?: string;
    /**
     * 映射列表
     * @type {Array<DwSyncTaskColumnMappingResponse>}
     * @memberof DwSyncTaskProductDetailResponse
     */
    column_mapping_list?: Array<DwSyncTaskColumnMappingResponse>;
    /**
     * 货币
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    currency?: string;
    /**
     * 图片根目录
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    image_root?: string;
    /**
     * 库存单ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    inventory_list_id?: string;
    /**
     * 区域语言
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    locale?: string;
    /**
     * 站点ID
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    site_id?: string;
    /**
     * 分辨率
     * @type {string}
     * @memberof DwSyncTaskProductDetailResponse
     */
    view_type?: string;
}

/**
 * 
 * @export
 * @interface DwSyncTaskSimpleResponse
 */
export interface DwSyncTaskSimpleResponse {
    /**
     * 创建时间
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    created_at?: string;
    /**
     * 修改人
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    created_by?: string;
    /**
     * 修改人ID
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    created_by_user_id?: string;
    /**
     * 是否删除
     * @type {boolean}
     * @memberof DwSyncTaskSimpleResponse
     */
    deleted?: boolean;
    /**
     * 描述
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    description?: string;
    /**
     * ID
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    id?: string;
    /**
     * 最后一次调度任务运行结束时间
     * @type {number}
     * @memberof DwSyncTaskSimpleResponse
     */
    last_stop_at?: number;
    /**
     * 调度结束时间
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    schedule_end_at?: string;
    /**
     * 调度执行间隔
     * @type {number}
     * @memberof DwSyncTaskSimpleResponse
     */
    schedule_interval?: number;
    /**
     * 调度开始时间
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    schedule_start_at?: string;
    /**
     * 调度类型
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    schedule_type?: DwSyncTaskSimpleResponse.ScheduleTypeEnum;
    /**
     * 任务状态
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    status?: DwSyncTaskSimpleResponse.StatusEnum;
    /**
     * 任务名
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    task_name?: string;
    /**
     * 任务类型
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    task_type?: DwSyncTaskSimpleResponse.TaskTypeEnum;
    /**
     * 修改时间
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    updated_at?: string;
    /**
     * 创建人
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    updated_by?: string;
    /**
     * 创建人ID
     * @type {string}
     * @memberof DwSyncTaskSimpleResponse
     */
    updated_by_user_id?: string;
}

/**
 * @export
 * @namespace DwSyncTaskSimpleResponse
 */
export namespace DwSyncTaskSimpleResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ScheduleTypeEnum {
        ONETIME = <any> 'ONE_TIME',
        ONGOING = <any> 'ON_GOING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ENABLED = <any> 'ENABLED',
        DISABLED = <any> 'DISABLED',
        DISABLING = <any> 'DISABLING'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TaskTypeEnum {
        PRODUCT = <any> 'PRODUCT',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskSourceColumnResponse
 */
export interface DwSyncTaskSourceColumnResponse {
    /**
     * 字段排序，小在前
     * @type {number}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    column_order?: number;
    /**
     * 主类型排序，小在前
     * @type {number}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    root_order?: number;
    /**
     * 主类型
     * @type {string}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    root_type?: DwSyncTaskSourceColumnResponse.RootTypeEnum;
    /**
     * 来源字段
     * @type {string}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    source_column_key?: string;
    /**
     * 来源字段名称
     * @type {string}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    source_column_name?: string;
    /**
     * 来源字段类型
     * @type {string}
     * @memberof DwSyncTaskSourceColumnResponse
     */
    source_type?: DwSyncTaskSourceColumnResponse.SourceTypeEnum;
}

/**
 * @export
 * @namespace DwSyncTaskSourceColumnResponse
 */
export namespace DwSyncTaskSourceColumnResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum RootTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        CUSTOMCATEGORY = <any> 'CUSTOM_CATEGORY',
        CUSTOMPRODUCT = <any> 'CUSTOM_PRODUCT'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SourceTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        CUSTOMCATEGORY = <any> 'CUSTOM_CATEGORY',
        CUSTOMPRODUCT = <any> 'CUSTOM_PRODUCT'
    }
}

/**
 * 
 * @export
 * @interface DwSyncTaskTargetColumnResponse
 */
export interface DwSyncTaskTargetColumnResponse {
    /**
     * 字段排序，小在前
     * @type {number}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    column_order?: number;
    /**
     * 自定义字段的命名空间
     * @type {number}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    namespace?: number;
    /**
     * 是否必须
     * @type {boolean}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    required?: boolean;
    /**
     * 主类型排序，小在前
     * @type {number}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    root_order?: number;
    /**
     * 主类型
     * @type {string}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    root_type?: DwSyncTaskTargetColumnResponse.RootTypeEnum;
    /**
     * 目标字段
     * @type {string}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    target_column_key?: string;
    /**
     * 目标字段名称
     * @type {string}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    target_column_name?: string;
    /**
     * 目标字段类型
     * @type {string}
     * @memberof DwSyncTaskTargetColumnResponse
     */
    target_type?: DwSyncTaskTargetColumnResponse.TargetTypeEnum;
}

/**
 * @export
 * @namespace DwSyncTaskTargetColumnResponse
 */
export namespace DwSyncTaskTargetColumnResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum RootTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        SKU = <any> 'SKU',
        ATTRIBUTE = <any> 'ATTRIBUTE',
        VARIATIONATTRIBUTE = <any> 'VARIATION_ATTRIBUTE',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER',
        CUSTOM = <any> 'CUSTOM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TargetTypeEnum {
        CATEGORY = <any> 'CATEGORY',
        PRODUCT = <any> 'PRODUCT',
        SKU = <any> 'SKU',
        ATTRIBUTE = <any> 'ATTRIBUTE',
        VARIATIONATTRIBUTE = <any> 'VARIATION_ATTRIBUTE',
        CUSTOMER = <any> 'CUSTOMER',
        ORDER = <any> 'ORDER',
        CUSTOM = <any> 'CUSTOM'
    }
}

/**
 * 
 * @export
 * @interface OrgMappingAuthUrlResponse
 */
export interface OrgMappingAuthUrlResponse {
    /**
     * Oauth2 Authorization Code Flow 的授权地址
     * @type {string}
     * @memberof OrgMappingAuthUrlResponse
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface OrgMappingsResponse
 */
export interface OrgMappingsResponse {
    /**
     * 租户id
     * @type {string}
     * @memberof OrgMappingsResponse
     */
    core_org_id?: string;
    /**
     * 租户名称
     * @type {string}
     * @memberof OrgMappingsResponse
     */
    core_org_name?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof OrgMappingsResponse
     */
    created_at?: string;
}

/**
 * 
 * @export
 * @interface OrganizationInfoResponse
 */
export interface OrganizationInfoResponse {
    /**
     * Organization's OpenAPI Key
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    api_key?: string;
    /**
     * asset cmde id
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    asset_cnde_id?: number;
    /**
     * asset crm id
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    asset_crm_id?: number;
    /**
     * asset ssc id
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    asset_ssc_id?: number;
    /**
     * asset ssm id
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    asset_ssm_id?: number;
    /**
     * Organization's Active CDN Domain
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    cdn_domain?: string;
    /**
     * Storefront open api usage statistics for the current month
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    current_month_storefront_open_api_use_total?: number;
    /**
     * default language
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    default_language?: string;
    /**
     * Storefront open api usage statistics for the last month
     * @type {number}
     * @memberof OrganizationInfoResponse
     */
    last_month_storefront_open_api_use_total?: number;
    /**
     * Organization Business Console Domain
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    org_business_console_domain?: string;
    /**
     * Organization ID
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    org_id?: string;
    /**
     * Organization Name
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    org_name?: string;
    /**
     * Organization's OpenAPI Domain.
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    org_open_api_domain?: string;
    /**
     * Organization's Secret Latest Reset Time
     * @type {string}
     * @memberof OrganizationInfoResponse
     */
    secret_latest_reset_at?: string;
}

/**
 * 
 * @export
 * @interface PageQueryResponseUserResponse
 */
export interface PageQueryResponseUserResponse {
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseUserResponse
     */
    current_page?: number;
    /**
     * 
     * @type {Array<UserResponse>}
     * @memberof PageQueryResponseUserResponse
     */
    list?: Array<UserResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseUserResponse
     */
    num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseUserResponse
     */
    total_num?: number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryResponseUserResponse
     */
    total_page?: number;
}

/**
 * 
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * 权限路径
     * @type {string}
     * @memberof PermissionResponse
     */
    path?: string;
    /**
     * 权限唯一key
     * @type {string}
     * @memberof PermissionResponse
     */
    permission_key?: string;
    /**
     * 权限名称
     * @type {string}
     * @memberof PermissionResponse
     */
    permission_name?: string;
    /**
     * 权限的应用类型
     * @type {string}
     * @memberof PermissionResponse
     */
    permission_type?: PermissionResponse.PermissionTypeEnum;
    /**
     * 权限的请求方式
     * @type {string}
     * @memberof PermissionResponse
     */
    request_method?: string;
}

/**
 * @export
 * @namespace PermissionResponse
 */
export namespace PermissionResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionTypeEnum {
        SSC = <any> 'SSC',
        SSM = <any> 'SSM',
        CRM = <any> 'CRM'
    }
}

/**
 * 
 * @export
 * @interface PermissionSetGroupResponse
 */
export interface PermissionSetGroupResponse {
    /**
     * 是否允许分配给角色
     * @type {boolean}
     * @memberof PermissionSetGroupResponse
     */
    allow_assign_status?: boolean;
    /**
     * 权限数据
     * @type {Array<PermissionResponse>}
     * @memberof PermissionSetGroupResponse
     */
    permissions?: Array<PermissionResponse>;
}

/**
 * 
 * @export
 * @interface PermissionSetResponse
 */
export interface PermissionSetResponse {
    /**
     * 权限集删分组数据
     * @type {PermissionSetGroupResponse}
     * @memberof PermissionSetResponse
     */
    delete_group: PermissionSetGroupResponse;
    /**
     * 权限集唯一key
     * @type {string}
     * @memberof PermissionSetResponse
     */
    permission_set_key: string;
    /**
     * 权限集类型
     * @type {string}
     * @memberof PermissionSetResponse
     */
    permission_set_type: PermissionSetResponse.PermissionSetTypeEnum;
    /**
     * 权限集读分组数据
     * @type {PermissionSetGroupResponse}
     * @memberof PermissionSetResponse
     */
    read_group: PermissionSetGroupResponse;
    /**
     * 权限集写分组数据
     * @type {PermissionSetGroupResponse}
     * @memberof PermissionSetResponse
     */
    write_group: PermissionSetGroupResponse;
}

/**
 * @export
 * @namespace PermissionSetResponse
 */
export namespace PermissionSetResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionSetTypeEnum {
        COMMON = <any> 'COMMON',
        SSC = <any> 'SSC',
        SSM = <any> 'SSM',
        CRM = <any> 'CRM'
    }
}

/**
 * 
 * @export
 * @interface ResendResult
 */
export interface ResendResult {
    /**
     * 
     * @type {boolean}
     * @memberof ResendResult
     */
    is_resent?: boolean;
}

/**
 * 
 * @export
 * @interface RoleCreateRequest
 */
export interface RoleCreateRequest {
    /**
     * description
     * @type {string}
     * @memberof RoleCreateRequest
     */
    description?: string;
    /**
     * permission_set
     * @type {Array<RolePermissionSetRequest>}
     * @memberof RoleCreateRequest
     */
    permission_set?: Array<RolePermissionSetRequest>;
    /**
     * role_name
     * @type {string}
     * @memberof RoleCreateRequest
     */
    role_name: string;
}

/**
 * 
 * @export
 * @interface RolePermissionSetRequest
 */
export interface RolePermissionSetRequest {
    /**
     * 权限集`删`分组下的权限，true代表拥有`删`分组下的所有接口权限，false代表该分组下任何接口都没有权限
     * @type {boolean}
     * @memberof RolePermissionSetRequest
     */
    delete_group: boolean;
    /**
     * 权限集的唯一key
     * @type {string}
     * @memberof RolePermissionSetRequest
     */
    permission_set_key: string;
    /**
     * 权限集的类型
     * @type {string}
     * @memberof RolePermissionSetRequest
     */
    permission_set_type: RolePermissionSetRequest.PermissionSetTypeEnum;
    /**
     * 权限集`读`分组下的权限，true代表拥有`读`分组下的所有接口权限，false代表该分组下任何接口都没有权限
     * @type {boolean}
     * @memberof RolePermissionSetRequest
     */
    read_group: boolean;
    /**
     * 权限集`写`分组下的权限，true代表拥有`写`分组下的所有接口权限，false代表该分组下任何接口都没有权限
     * @type {boolean}
     * @memberof RolePermissionSetRequest
     */
    write_group: boolean;
}

/**
 * @export
 * @namespace RolePermissionSetRequest
 */
export namespace RolePermissionSetRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum PermissionSetTypeEnum {
        COMMON = <any> 'COMMON',
        SSC = <any> 'SSC',
        SSM = <any> 'SSM',
        CRM = <any> 'CRM'
    }
}

/**
 * 
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     * 角色创建时间
     * @type {number}
     * @memberof RoleResponse
     */
    created_at?: number;
    /**
     * 角色的创建人
     * @type {string}
     * @memberof RoleResponse
     */
    created_by?: string;
    /**
     * 角色的创建人userId
     * @type {number}
     * @memberof RoleResponse
     */
    created_by_user_id?: number;
    /**
     * 角色描述
     * @type {string}
     * @memberof RoleResponse
     */
    description?: string;
    /**
     * 角色id
     * @type {string}
     * @memberof RoleResponse
     */
    id?: string;
    /**
     * 角色的权限集
     * @type {Array<RolePermissionSetRequest>}
     * @memberof RoleResponse
     */
    permission_set?: Array<RolePermissionSetRequest>;
    /**
     * 废弃申明：角色翻译key，后期版本会移除该属性，请不要使用
     * @type {string}
     * @memberof RoleResponse
     */
    role_key?: string;
    /**
     * 角色名称
     * @type {string}
     * @memberof RoleResponse
     */
    role_name?: string;
    /**
     * 是否为系统默认角色
     * @type {boolean}
     * @memberof RoleResponse
     */
    system_default?: boolean;
    /**
     * 角色的更新时间
     * @type {number}
     * @memberof RoleResponse
     */
    updated_at?: number;
    /**
     * 角色的最后的更新人
     * @type {string}
     * @memberof RoleResponse
     */
    updated_by?: string;
    /**
     * 角色的最后的更新人userId
     * @type {number}
     * @memberof RoleResponse
     */
    updated_by_user_id?: number;
    /**
     * 当前角色绑定用户的个数
     * @type {string}
     * @memberof RoleResponse
     */
    user_count?: string;
}

/**
 * 
 * @export
 * @interface RoleUpdateRequest
 */
export interface RoleUpdateRequest {
    /**
     * description
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    description?: string;
    /**
     * permission_set
     * @type {Array<RolePermissionSetRequest>}
     * @memberof RoleUpdateRequest
     */
    permission_set?: Array<RolePermissionSetRequest>;
    /**
     * role_name
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    role_name?: string;
}

/**
 * 
 * @export
 * @interface SendSMSSecretSecurityRequest
 */
export interface SendSMSSecretSecurityRequest {
    /**
     * SMS Event
     * @type {string}
     * @memberof SendSMSSecretSecurityRequest
     */
    event: SendSMSSecretSecurityRequest.EventEnum;
}

/**
 * @export
 * @namespace SendSMSSecretSecurityRequest
 */
export namespace SendSMSSecretSecurityRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventEnum {
        CREATEBUSINESSOPENAPISECRETKEY = <any> 'CREATE_BUSINESS_OPEN_API_SECRET_KEY',
        CHANGEBUSINESSOPENAPISECRETKEYSTATUS = <any> 'CHANGE_BUSINESS_OPEN_API_SECRET_KEY_STATUS',
        DELETEBUSINESSOPENAPISECRETKEY = <any> 'DELETE_BUSINESS_OPEN_API_SECRET_KEY'
    }
}

/**
 * 
 * @export
 * @interface SimplifiedCDNSettingResponse
 */
export interface SimplifiedCDNSettingResponse {
    /**
     * 
     * @type {string}
     * @memberof SimplifiedCDNSettingResponse
     */
    domain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimplifiedCDNSettingResponse
     */
    domain_cname_bound?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimplifiedCDNSettingResponse
     */
    domain_cname_bound_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimplifiedCDNSettingResponse
     */
    domain_owner_verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimplifiedCDNSettingResponse
     */
    domain_owner_verified_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimplifiedCDNSettingResponse
     */
    https_cert_uploaded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimplifiedCDNSettingResponse
     */
    https_cert_uploaded_at?: string;
}

/**
 * 
 * @export
 * @interface SocialProfileEditRequest
 */
export interface SocialProfileEditRequest {
    /**
     * channelId
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    channel_id: string;
    /**
     * crmUserId
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    crm_id: string;
    /**
     * 根据类型不同为不同的id, 1:wecomUserId
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    external_id: string;
    /**
     * 根据类型不同为不同的name, 1:wecomUserName
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    external_name?: string;
    /**
     * 身份类型 WECOM
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    profile_type: SocialProfileEditRequest.ProfileTypeEnum;
    /**
     * 状态 DISABLED, ENABLED
     * @type {string}
     * @memberof SocialProfileEditRequest
     */
    status: SocialProfileEditRequest.StatusEnum;
}

/**
 * @export
 * @namespace SocialProfileEditRequest
 */
export namespace SocialProfileEditRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ProfileTypeEnum {
        WECOM = <any> 'WECOM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface SocialProfileResponse
 */
export interface SocialProfileResponse {
    /**
     * channelId
     * @type {string}
     * @memberof SocialProfileResponse
     */
    channel_id?: string;
    /**
     * crmUserId
     * @type {string}
     * @memberof SocialProfileResponse
     */
    crm_id?: string;
    /**
     * 根据身份类型不同为不同的id, 1:wecomUserId
     * @type {string}
     * @memberof SocialProfileResponse
     */
    external_id?: string;
    /**
     * 根据身份类型不同为不同的name, 1:wecomUserName
     * @type {string}
     * @memberof SocialProfileResponse
     */
    external_name?: string;
    /**
     * id
     * @type {string}
     * @memberof SocialProfileResponse
     */
    id?: string;
    /**
     * 身份类型 WECOM
     * @type {string}
     * @memberof SocialProfileResponse
     */
    profile_type?: SocialProfileResponse.ProfileTypeEnum;
    /**
     * 状态 DISABLED, ENABLED
     * @type {string}
     * @memberof SocialProfileResponse
     */
    status?: SocialProfileResponse.StatusEnum;
}

/**
 * @export
 * @namespace SocialProfileResponse
 */
export namespace SocialProfileResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ProfileTypeEnum {
        WECOM = <any> 'WECOM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        DISABLED = <any> 'DISABLED',
        ENABLED = <any> 'ENABLED'
    }
}

/**
 * 
 * @export
 * @interface TicketDesignatedType
 */
export interface TicketDesignatedType {
    /**
     * 
     * @type {string}
     * @memberof TicketDesignatedType
     */
    join_type?: TicketDesignatedType.JoinTypeEnum;
}

/**
 * @export
 * @namespace TicketDesignatedType
 */
export namespace TicketDesignatedType {
    /**
     * @export
     * @enum {string}
     */
    export enum JoinTypeEnum {
        ACCEPT = <any> 'JOIN_BY_ACCEPT',
        ACTIVATEACCOUNT = <any> 'JOIN_BY_ACTIVATE_ACCOUNT'
    }
}

/**
 * 
 * @export
 * @interface TicketResetPasswdRequest
 */
export interface TicketResetPasswdRequest {
    /**
     * SMS security code
     * @type {string}
     * @memberof TicketResetPasswdRequest
     */
    code: string;
    /**
     * Confirm Passwd
     * @type {string}
     * @memberof TicketResetPasswdRequest
     */
    confirm_passwd: string;
    /**
     * 手机号区号,例如中国大陆: +86，美国、加拿大：+1
     * @type {string}
     * @memberof TicketResetPasswdRequest
     */
    country_code: string;
    /**
     * passwd
     * @type {string}
     * @memberof TicketResetPasswdRequest
     */
    passwd: string;
    /**
     * Phone number
     * @type {string}
     * @memberof TicketResetPasswdRequest
     */
    phone_number: string;
}

/**
 * 
 * @export
 * @interface UpdateBlockStrategiesRequest
 */
export interface UpdateBlockStrategiesRequest {
    /**
     * 1-blockLoginAndRegister,2-blockPlaceOrder
     * @type {Array<number>}
     * @memberof UpdateBlockStrategiesRequest
     */
    block_strategies?: Array<UpdateBlockStrategiesRequest.BlockStrategiesEnum>;
}

/**
 * @export
 * @namespace UpdateBlockStrategiesRequest
 */
export namespace UpdateBlockStrategiesRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum BlockStrategiesEnum {
        _1 = <any> '1',
        _2 = <any> '2'
    }
}

/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    role_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    user_email: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    user_firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    user_lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    user_nickname: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    user_profile_remark?: string;
}

/**
 * 
 * @export
 * @interface UserDeletionResult
 */
export interface UserDeletionResult {
    /**
     * 
     * @type {boolean}
     * @memberof UserDeletionResult
     */
    is_deleted?: boolean;
}

/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * cnde是否已经绑定asset，并且asset是否可用，如果可用返回true，不可用返回false
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    asset_cnde_enabled?: boolean;
    /**
     * cnde asset id
     * @type {string}
     * @memberof UserProfileResponse
     */
    asset_cnde_id?: string;
    /**
     * crm是否已经绑定asset，并且asset是否可用，如果可用返回true，不可用返回false
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    asset_crm_enabled?: boolean;
    /**
     * crm asset id
     * @type {string}
     * @memberof UserProfileResponse
     */
    asset_crm_id?: string;
    /**
     * ssc是否已经绑定asset，并且asset是否可用，如果可用返回true，不可用返回false
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    asset_ssc_enabled?: boolean;
    /**
     * ssc asset id
     * @type {string}
     * @memberof UserProfileResponse
     */
    asset_ssc_id?: string;
    /**
     * ssm是否已经绑定asset，并且asset是否可用，如果可用返回true，不可用返回false
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    asset_ssm_enabled?: boolean;
    /**
     * ssm asset id
     * @type {string}
     * @memberof UserProfileResponse
     */
    asset_ssm_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    created_at?: string;
    /**
     * Created By Username
     * @type {string}
     * @memberof UserProfileResponse
     */
    created_by?: string;
    /**
     * Created By User ID
     * @type {string}
     * @memberof UserProfileResponse
     */
    created_by_user_id?: string;
    /**
     * User's Role ID
     * @type {string}
     * @memberof UserProfileResponse
     */
    role_id?: string;
    /**
     * Whether the user is a super administrator
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    super_admin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    updated_at?: string;
    /**
     * Updated By Username
     * @type {string}
     * @memberof UserProfileResponse
     */
    updated_by?: string;
    /**
     * Updated By User ID
     * @type {string}
     * @memberof UserProfileResponse
     */
    updated_by_user_id?: string;
    /**
     * User's Email Address.
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_email?: string;
    /**
     * User's Firstname.
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_firstname?: string;
    /**
     * User ID.
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_id?: string;
    /**
     * User's Lastname.
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_lastname?: string;
    /**
     * User's Nickname
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_nickname?: string;
    /**
     * User's Org ID.
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_org_id?: string;
    /**
     * remark
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_profile_remark?: string;
    /**
     * User's status, active/inactive/deactivated
     * @type {string}
     * @memberof UserProfileResponse
     */
    user_status?: string;
}

/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    created_at?: string;
    /**
     * Created By Username
     * @type {string}
     * @memberof UserResponse
     */
    created_by?: string;
    /**
     * Created By User ID
     * @type {string}
     * @memberof UserResponse
     */
    created_by_user_id?: string;
    /**
     * User's Role ID
     * @type {string}
     * @memberof UserResponse
     */
    role_id?: string;
    /**
     * Whether the user is a super administrator
     * @type {boolean}
     * @memberof UserResponse
     */
    super_admin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    updated_at?: string;
    /**
     * Updated By Username
     * @type {string}
     * @memberof UserResponse
     */
    updated_by?: string;
    /**
     * Updated By User ID
     * @type {string}
     * @memberof UserResponse
     */
    updated_by_user_id?: string;
    /**
     * User's Email Address.
     * @type {string}
     * @memberof UserResponse
     */
    user_email?: string;
    /**
     * User's Firstname.
     * @type {string}
     * @memberof UserResponse
     */
    user_firstname?: string;
    /**
     * User ID.
     * @type {string}
     * @memberof UserResponse
     */
    user_id?: string;
    /**
     * User's Lastname.
     * @type {string}
     * @memberof UserResponse
     */
    user_lastname?: string;
    /**
     * User's Nickname
     * @type {string}
     * @memberof UserResponse
     */
    user_nickname?: string;
    /**
     * User's Org ID.
     * @type {string}
     * @memberof UserResponse
     */
    user_org_id?: string;
    /**
     * remark
     * @type {string}
     * @memberof UserResponse
     */
    user_profile_remark?: string;
    /**
     * User's status, active/inactive/deactivated
     * @type {string}
     * @memberof UserResponse
     */
    user_status?: string;
}

/**
 * 
 * @export
 * @interface UserSelfUpdateRequest
 */
export interface UserSelfUpdateRequest {
    /**
     * firstname
     * @type {string}
     * @memberof UserSelfUpdateRequest
     */
    user_firstname: string;
    /**
     * lastname
     * @type {string}
     * @memberof UserSelfUpdateRequest
     */
    user_lastname: string;
    /**
     * User's Nickname
     * @type {string}
     * @memberof UserSelfUpdateRequest
     */
    user_nickname?: string;
}

/**
 * 
 * @export
 * @interface UserUpdateRequest
 */
export interface UserUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    role_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    user_firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    user_lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    user_nickname: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateRequest
     */
    user_profile_remark?: string;
}




export interface IgetAccessPolicyListByRoleIdUsingGETParams {
  
  
  role_id: string, 
  
}

/**
 *AccessPolicyControllerApi - fetch parameter creator
 *@export
 */
export const AccessPolicyControllerApiParamCreator = {
  /**
    *
    *@summary get access policy list by role_ Id, this interface will be gradually discarded, please do not use it
    *@param {string} role_id 
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAccessPolicyListByRoleIdUsingGET(params = {} as IgetAccessPolicyListByRoleIdUsingGETParams, options: any = {}): FetchArgs {
    const {  role_id,    } = params

    // verify required path 'role_id' is not null or undefined
    if (role_id === null || role_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('role_id', 'Required parameter role_id was null or undefined when calling getAccessPolicyListByRoleIdUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/access_policies/{role_id}`.includes(prefix) ? `/business/v1/organization/access_policies/{role_id}` : prefix + `/business/v1/organization/access_policies/{role_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"role_id"}}`, encodeURIComponent(String(role_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetExpectAnnouncementUsingGETParams {
  
  
  
  
}

/**
 *AnnouncementControllerApi - fetch parameter creator
 *@export
 */
export const AnnouncementControllerApiParamCreator = {
  /**
    *
    *@summary Get announcements that meet the prompt
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getExpectAnnouncementUsingGET(params = {} as IgetExpectAnnouncementUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/announcements`.includes(prefix) ? `/business/v1/organization/announcements` : prefix + `/business/v1/organization/announcements`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateBusinessUserOpenApiSecretKeyUsingPOSTParams {
  request: BusinessUserOpenApiSecretKeyCreateRequest, 
  
  
  
}
export interface IdeleteBusinessUserOpenApiSecretKeyUsingDELETEParams {
  request: BusinessUserOpenApiSecretKeyDeleteRequest, 
  
  id: string, 
  
}
export interface IgetBusinessUserOpenApiSecretKeyListUsingGETParams {
  
  
  
  
}
export interface IsendSMSSecretSecurityCodeUsingPOSTParams {
  request: SendSMSSecretSecurityRequest, 
  
  
  
}
export interface IupdateBusinessUserOpenApiSecretKeyStatusUsingPATCHParams {
  request: BusinessUserOpenApiSecretKeyUpdateStatusRequest, 
  
  id: string, 
  
}

/**
 *BusinessUserOpenApiSecretKeyControllerApi - fetch parameter creator
 *@export
 */
export const BusinessUserOpenApiSecretKeyControllerApiParamCreator = {
  /**
    *
    *@summary create business user open api secret key
    *@param {string} cookie 
    *@param {BusinessUserOpenApiSecretKeyCreateRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createBusinessUserOpenApiSecretKeyUsingPOST(params = {} as IcreateBusinessUserOpenApiSecretKeyUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling createBusinessUserOpenApiSecretKeyUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/secrets`.includes(prefix) ? `/business/v1/organization/secrets` : prefix + `/business/v1/organization/secrets`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"BusinessUserOpenApiSecretKeyCreateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete business user open api secret key
    *@param {string} cookie 
    *@param {string} id id
    *@param {BusinessUserOpenApiSecretKeyDeleteRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteBusinessUserOpenApiSecretKeyUsingDELETE(params = {} as IdeleteBusinessUserOpenApiSecretKeyUsingDELETEParams, options: any = {}): FetchArgs {
    const { request,  id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling deleteBusinessUserOpenApiSecretKeyUsingDELETE.');
    }

    // verify required path 'id' is not null or undefined
    if (id === null || id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteBusinessUserOpenApiSecretKeyUsingDELETE.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/secrets/{id}`.includes(prefix) ? `/business/v1/organization/secrets/{id}` : prefix + `/business/v1/organization/secrets/{id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"BusinessUserOpenApiSecretKeyDeleteRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary get business user open api secret key list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getBusinessUserOpenApiSecretKeyListUsingGET(params = {} as IgetBusinessUserOpenApiSecretKeyListUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/secrets`.includes(prefix) ? `/business/v1/organization/secrets` : prefix + `/business/v1/organization/secrets`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary send SMS secret security code
    *@param {string} cookie 
    *@param {SendSMSSecretSecurityRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  sendSMSSecretSecurityCodeUsingPOST(params = {} as IsendSMSSecretSecurityCodeUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling sendSMSSecretSecurityCodeUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/secrets/security/sms`.includes(prefix) ? `/business/v1/organization/secrets/security/sms` : prefix + `/business/v1/organization/secrets/security/sms`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SendSMSSecretSecurityRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update business user open api secret key status
    *@param {string} cookie 
    *@param {string} id id
    *@param {BusinessUserOpenApiSecretKeyUpdateStatusRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBusinessUserOpenApiSecretKeyStatusUsingPATCH(params = {} as IupdateBusinessUserOpenApiSecretKeyStatusUsingPATCHParams, options: any = {}): FetchArgs {
    const { request,  id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBusinessUserOpenApiSecretKeyStatusUsingPATCH.');
    }

    // verify required path 'id' is not null or undefined
    if (id === null || id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateBusinessUserOpenApiSecretKeyStatusUsingPATCH.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/secrets/{id}/status`.includes(prefix) ? `/business/v1/organization/secrets/{id}/status` : prefix + `/business/v1/organization/secrets/{id}/status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"BusinessUserOpenApiSecretKeyUpdateStatusRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IclearLatestSettingUsingDELETEParams {
  
  
  
  
}
export interface IgetActiveSettingUsingGETParams {
  
  
  
  
}
export interface IgetDomainBindingInfoUsingPOSTParams {
  request: CDNDomainBindingInfoRequest, 
  
  
  
}
export interface IgetLatestSettingUsingGETParams {
  
  
  
  
}
export interface IuploadSSLCertificateUsingPOSTParams {
  request: CDNDomainSSLCertificateInfoRequest, 
  
  
  
}
export interface IverifyDomainBindingUsingPOSTParams {
  request: CDNDomainBindingVerificationRequest, 
  
  
  
}

/**
 *CdnControllerApi - fetch parameter creator
 *@export
 */
export const CdnControllerApiParamCreator = {
  /**
    *
    *@summary delete latest but not active CDN setting
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  clearLatestSettingUsingDELETE(params = {} as IclearLatestSettingUsingDELETEParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/latest-config`.includes(prefix) ? `/business/v1/organization/cdn/latest-config` : prefix + `/business/v1/organization/cdn/latest-config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve active CDN setting
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getActiveSettingUsingGET(params = {} as IgetActiveSettingUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/config`.includes(prefix) ? `/business/v1/organization/cdn/config` : prefix + `/business/v1/organization/cdn/config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve CDN (TXT or CNAME) binding info
    *@param {string} cookie 
    *@param {CDNDomainBindingInfoRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getDomainBindingInfoUsingPOST(params = {} as IgetDomainBindingInfoUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling getDomainBindingInfoUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/binding_info`.includes(prefix) ? `/business/v1/organization/cdn/binding_info` : prefix + `/business/v1/organization/cdn/binding_info`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CDNDomainBindingInfoRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve latest but not active CDN setting
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getLatestSettingUsingGET(params = {} as IgetLatestSettingUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/latest-config`.includes(prefix) ? `/business/v1/organization/cdn/latest-config` : prefix + `/business/v1/organization/cdn/latest-config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary upload CDN SSl Certificate
    *@param {string} cookie 
    *@param {CDNDomainSSLCertificateInfoRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  uploadSSLCertificateUsingPOST(params = {} as IuploadSSLCertificateUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling uploadSSLCertificateUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/binding_ssl`.includes(prefix) ? `/business/v1/organization/cdn/binding_ssl` : prefix + `/business/v1/organization/cdn/binding_ssl`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CDNDomainSSLCertificateInfoRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary trigger CDN (TXT or CNAME) binding verification
    *@param {string} cookie 
    *@param {CDNDomainBindingVerificationRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  verifyDomainBindingUsingPOST(params = {} as IverifyDomainBindingUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling verifyDomainBindingUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/cdn/binding_verify`.includes(prefix) ? `/business/v1/organization/cdn/binding_verify` : prefix + `/business/v1/organization/cdn/binding_verify`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"CDNDomainBindingVerificationRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateBaseConfigUsingPOSTParams {
  request: DwSyncBaseConfigEditRequest, 
  
  
  
}
export interface IcreateTaskUsingPOSTParams {
  request: DwSyncTaskEditRequest, 
  
  
  
}
export interface IdeleteTaskUsingDELETEParams {
  
  
  task_id: string, 
  
}
export interface IgetBaseConfigUsingGETParams {
  
  
  
  
}
export interface IgetSiteUsingGETParams {
  
  locale_id?: string, 
  site_id: string, 
  
}
export interface IgetTaskUsingGETParams {
  
  
  task_id: string, 
  
}
export interface IlistApiVersionUsingGETParams {
  
  
  
  
}
export interface IlistCatalogUsingGETParams {
  
  locale_id?: string, 
  
  
}
export interface IlistInventoryListUsingGETParams {
  
  
  
  
}
export interface IlistLocaleUsingGETParams {
  
  
  
  
}
export interface IlistSiteUsingGETParams {
  
  locale_id?: string, 
  
  
}
export interface IlistTaskJobUsingGETParams {
  
  end_at?: string, job_stop_type?: 'SUCCESS' | 'FAIL' | 'SUCCESS_WITH_ERROR' | 'USER_INTERRUPT' | 'SERVICE_INTERRUPT', start_at?: string, 
  task_id: string, 
  
}
export interface IlistTaskSourceColumnUsingGETParams {
  
  locale_id: string, task_type: 'PRODUCT' | 'CUSTOMER' | 'ORDER', 
  
  
}
export interface IlistTaskSystemColumnMappingUsingGETParams {
  
  task_type: 'PRODUCT' | 'CUSTOMER' | 'ORDER', 
  
  
}
export interface IlistTaskTargetColumnUsingGETParams {
  
  task_type: 'PRODUCT' | 'CUSTOMER' | 'ORDER', 
  
  
}
export interface IlistTaskUsingGETParams {
  
  schedule_type?: Array<'ONE_TIME' | 'ON_GOING'>, status?: Array<'ENABLED' | 'DISABLED' | 'DISABLING'>, task_name?: string, task_type?: Array<'PRODUCT' | 'CUSTOMER' | 'ORDER'>, 
  
  
}
export interface IlistTaskViewTypeUsingGETParams {
  
  task_type: 'PRODUCT' | 'CUSTOMER' | 'ORDER', 
  
  
}
export interface IupdateBaseConfigUsingPUTParams {
  request: DwSyncBaseConfigEditRequest, 
  
  
  
}
export interface IupdateTaskStatusUsingPATCHParams {
  
  
  status: 'ENABLED' | 'DISABLED' | 'DISABLING', task_id: string, 
  
}
export interface IupdateTaskUsingPUTParams {
  request: DwSyncTaskEditRequest, 
  
  task_id: string, 
  
}

/**
 *DemandwareSyncControllerApi - fetch parameter creator
 *@export
 */
export const DemandwareSyncControllerApiParamCreator = {
  /**
    *
    *@summary create demandware sync base config
    *@param {string} cookie 
    *@param {DwSyncBaseConfigEditRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createBaseConfigUsingPOST(params = {} as IcreateBaseConfigUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling createBaseConfigUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/base_config`.includes(prefix) ? `/business/v1/organization/demandware/sync/base_config` : prefix + `/business/v1/organization/demandware/sync/base_config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"DwSyncBaseConfigEditRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary create demandware sync task
    *@param {string} cookie 
    *@param {DwSyncTaskEditRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createTaskUsingPOST(params = {} as IcreateTaskUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling createTaskUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task`.includes(prefix) ? `/business/v1/organization/demandware/sync/task` : prefix + `/business/v1/organization/demandware/sync/task`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"DwSyncTaskEditRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete demandware sync task
    *@param {string} cookie 
    *@param {string} task_id task_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteTaskUsingDELETE(params = {} as IdeleteTaskUsingDELETEParams, options: any = {}): FetchArgs {
    const {  task_id,    } = params

    // verify required path 'task_id' is not null or undefined
    if (task_id === null || task_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_id', 'Required parameter task_id was null or undefined when calling deleteTaskUsingDELETE.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/{task_id}`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/{task_id}` : prefix + `/business/v1/organization/demandware/sync/task/{task_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"task_id"}}`, encodeURIComponent(String(task_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync base config
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getBaseConfigUsingGET(params = {} as IgetBaseConfigUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/base_config`.includes(prefix) ? `/business/v1/organization/demandware/sync/base_config` : prefix + `/business/v1/organization/demandware/sync/base_config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware site detail
    *@param {string} cookie 
    *@param {string} site_id site_id
    *@param {string} [locale_id] locale_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getSiteUsingGET(params = {} as IgetSiteUsingGETParams, options: any = {}): FetchArgs {
    const {  site_id,  locale_id,   } = params

    // verify required path 'site_id' is not null or undefined
    if (site_id === null || site_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('site_id', 'Required parameter site_id was null or undefined when calling getSiteUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/site/{site_id}`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/site/{site_id}` : prefix + `/business/v1/organization/demandware/sync/config/site/{site_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"site_id"}}`, encodeURIComponent(String(site_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (locale_id !== undefined) {
        localVarQueryParameter.locale_id = locale_id;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync task detail
    *@param {string} cookie 
    *@param {string} task_id task_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getTaskUsingGET(params = {} as IgetTaskUsingGETParams, options: any = {}): FetchArgs {
    const {  task_id,    } = params

    // verify required path 'task_id' is not null or undefined
    if (task_id === null || task_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_id', 'Required parameter task_id was null or undefined when calling getTaskUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/{task_id}`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/{task_id}` : prefix + `/business/v1/organization/demandware/sync/task/{task_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"task_id"}}`, encodeURIComponent(String(task_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware api version list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listApiVersionUsingGET(params = {} as IlistApiVersionUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/api_version`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/api_version` : prefix + `/business/v1/organization/demandware/sync/config/api_version`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware catalog list
    *@param {string} cookie 
    *@param {string} [locale_id] locale_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listCatalogUsingGET(params = {} as IlistCatalogUsingGETParams, options: any = {}): FetchArgs {
    const {   locale_id,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/catalog`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/catalog` : prefix + `/business/v1/organization/demandware/sync/config/catalog`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (locale_id !== undefined) {
        localVarQueryParameter.locale_id = locale_id;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware inventoryList list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listInventoryListUsingGET(params = {} as IlistInventoryListUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/inventory_list`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/inventory_list` : prefix + `/business/v1/organization/demandware/sync/config/inventory_list`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware locale list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listLocaleUsingGET(params = {} as IlistLocaleUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/locale`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/locale` : prefix + `/business/v1/organization/demandware/sync/config/locale`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware site list
    *@param {string} cookie 
    *@param {string} [locale_id] locale_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listSiteUsingGET(params = {} as IlistSiteUsingGETParams, options: any = {}): FetchArgs {
    const {   locale_id,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/config/site`.includes(prefix) ? `/business/v1/organization/demandware/sync/config/site` : prefix + `/business/v1/organization/demandware/sync/config/site`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (locale_id !== undefined) {
        localVarQueryParameter.locale_id = locale_id;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync task job list
    *@param {string} cookie 
    *@param {string} task_id task_id
    *@param {string} [end_at] end_at
    *@param {'SUCCESS' | 'FAIL' | 'SUCCESS_WITH_ERROR' | 'USER_INTERRUPT' | 'SERVICE_INTERRUPT'} [job_stop_type] job_stop_type
    *@param {string} [start_at] start_at
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskJobUsingGET(params = {} as IlistTaskJobUsingGETParams, options: any = {}): FetchArgs {
    const {  task_id,  end_at, job_stop_type, start_at,   } = params

    // verify required path 'task_id' is not null or undefined
    if (task_id === null || task_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_id', 'Required parameter task_id was null or undefined when calling listTaskJobUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/job/{task_id}`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/job/{task_id}` : prefix + `/business/v1/organization/demandware/sync/task/job/{task_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"task_id"}}`, encodeURIComponent(String(task_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (end_at !== undefined) {
        localVarQueryParameter.end_at = end_at;
    }

    if (job_stop_type !== undefined) {
        localVarQueryParameter.job_stop_type = job_stop_type;
    }

    if (start_at !== undefined) {
        localVarQueryParameter.start_at = start_at;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync source column list
    *@param {string} cookie 
    *@param {string} locale_id locale_id
    *@param {'PRODUCT' | 'CUSTOMER' | 'ORDER'} task_type task_type
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskSourceColumnUsingGET(params = {} as IlistTaskSourceColumnUsingGETParams, options: any = {}): FetchArgs {
    const {   locale_id, task_type,   } = params


    // verify required query 'locale_id' is not null or undefined
    if (locale_id === null || locale_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('locale_id', 'Required parameter locale_id was null or undefined when calling listTaskSourceColumnUsingGET.');
    }
    // verify required query 'task_type' is not null or undefined
    if (task_type === null || task_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_type', 'Required parameter task_type was null or undefined when calling listTaskSourceColumnUsingGET.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/source_column`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/source_column` : prefix + `/business/v1/organization/demandware/sync/task/source_column`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (locale_id !== undefined) {
        localVarQueryParameter.locale_id = locale_id;
    }

    if (task_type !== undefined) {
        localVarQueryParameter.task_type = task_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync system defined column mapping
    *@param {string} cookie 
    *@param {'PRODUCT' | 'CUSTOMER' | 'ORDER'} task_type task_type
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskSystemColumnMappingUsingGET(params = {} as IlistTaskSystemColumnMappingUsingGETParams, options: any = {}): FetchArgs {
    const {   task_type,   } = params


    // verify required query 'task_type' is not null or undefined
    if (task_type === null || task_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_type', 'Required parameter task_type was null or undefined when calling listTaskSystemColumnMappingUsingGET.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/system_column_mapping`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/system_column_mapping` : prefix + `/business/v1/organization/demandware/sync/task/system_column_mapping`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (task_type !== undefined) {
        localVarQueryParameter.task_type = task_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync target column list
    *@param {string} cookie 
    *@param {'PRODUCT' | 'CUSTOMER' | 'ORDER'} task_type task_type
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskTargetColumnUsingGET(params = {} as IlistTaskTargetColumnUsingGETParams, options: any = {}): FetchArgs {
    const {   task_type,   } = params


    // verify required query 'task_type' is not null or undefined
    if (task_type === null || task_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_type', 'Required parameter task_type was null or undefined when calling listTaskTargetColumnUsingGET.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/target_column`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/target_column` : prefix + `/business/v1/organization/demandware/sync/task/target_column`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (task_type !== undefined) {
        localVarQueryParameter.task_type = task_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync task list
    *@param {string} cookie 
    *@param {Array<'ONE_TIME' | 'ON_GOING'>} [schedule_type] 调度类型
    *@param {Array<'ENABLED' | 'DISABLED' | 'DISABLING'>} [status] 任务状态
    *@param {string} [task_name] 任务名称，模糊搜索
    *@param {Array<'PRODUCT' | 'CUSTOMER' | 'ORDER'>} [task_type] 任务类型
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskUsingGET(params = {} as IlistTaskUsingGETParams, options: any = {}): FetchArgs {
    const {   schedule_type, status, task_name, task_type,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task`.includes(prefix) ? `/business/v1/organization/demandware/sync/task` : prefix + `/business/v1/organization/demandware/sync/task`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (schedule_type) {
      localVarQueryParameter['scheduleType'] = schedule_type;
    }

    if (status) {
      localVarQueryParameter['status'] = status;
    }

    if (task_name !== undefined) {
        localVarQueryParameter.taskName = task_name;
    }

    if (task_type) {
      localVarQueryParameter['taskType'] = task_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve demandware sync default view type list
    *@param {string} cookie 
    *@param {'PRODUCT' | 'CUSTOMER' | 'ORDER'} task_type task_type
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listTaskViewTypeUsingGET(params = {} as IlistTaskViewTypeUsingGETParams, options: any = {}): FetchArgs {
    const {   task_type,   } = params


    // verify required query 'task_type' is not null or undefined
    if (task_type === null || task_type === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_type', 'Required parameter task_type was null or undefined when calling listTaskViewTypeUsingGET.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/view_type`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/view_type` : prefix + `/business/v1/organization/demandware/sync/task/view_type`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (task_type !== undefined) {
        localVarQueryParameter.task_type = task_type;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update demandware sync base config
    *@param {string} cookie 
    *@param {DwSyncBaseConfigEditRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBaseConfigUsingPUT(params = {} as IupdateBaseConfigUsingPUTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBaseConfigUsingPUT.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/base_config`.includes(prefix) ? `/business/v1/organization/demandware/sync/base_config` : prefix + `/business/v1/organization/demandware/sync/base_config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"DwSyncBaseConfigEditRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update demandware sync task status
    *@param {string} cookie 
    *@param {'ENABLED' | 'DISABLED' | 'DISABLING'} status status
    *@param {string} task_id task_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateTaskStatusUsingPATCH(params = {} as IupdateTaskStatusUsingPATCHParams, options: any = {}): FetchArgs {
    const {  status, task_id,    } = params

    // verify required path 'status' is not null or undefined
    if (status === null || status === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('status', 'Required parameter status was null or undefined when calling updateTaskStatusUsingPATCH.');
    }
    // verify required path 'task_id' is not null or undefined
    if (task_id === null || task_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_id', 'Required parameter task_id was null or undefined when calling updateTaskStatusUsingPATCH.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/{task_id}/status/{status}`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/{task_id}/status/{status}` : prefix + `/business/v1/organization/demandware/sync/task/{task_id}/status/{status}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"status"}}`, encodeURIComponent(String(status)))
        .replace(`{${"task_id"}}`, encodeURIComponent(String(task_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update demandware sync task
    *@param {string} cookie 
    *@param {DwSyncTaskEditRequest} request request
    *@param {string} task_id task_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateTaskUsingPUT(params = {} as IupdateTaskUsingPUTParams, options: any = {}): FetchArgs {
    const { request,  task_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateTaskUsingPUT.');
    }

    // verify required path 'task_id' is not null or undefined
    if (task_id === null || task_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('task_id', 'Required parameter task_id was null or undefined when calling updateTaskUsingPUT.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/demandware/sync/task/{task_id}`.includes(prefix) ? `/business/v1/organization/demandware/sync/task/{task_id}` : prefix + `/business/v1/organization/demandware/sync/task/{task_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"task_id"}}`, encodeURIComponent(String(task_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"DwSyncTaskEditRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IconfirmUsingPOSTParams {
  
  
  
  
}
export interface IgetAuthUrlUsingGETParams {
  
  
  
  
}
export interface IgetOrgMappingsUsingGETParams {
  
  
  
  
}
export interface IreceiveCodeUsingGETParams {
  code?: string, state?: string, 
  
  
  
}

/**
 *OrgMappingControllerApi - fetch parameter creator
 *@export
 */
export const OrgMappingControllerApiParamCreator = {
  /**
    *
    *@summary confirm
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  confirmUsingPOST(params = {} as IconfirmUsingPOSTParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/org_mappings/confirm`.includes(prefix) ? `/business/v1/organization/org_mappings/confirm` : prefix + `/business/v1/organization/org_mappings/confirm`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary getAuthUrl
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAuthUrlUsingGET(params = {} as IgetAuthUrlUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/org_mappings/auth_url`.includes(prefix) ? `/business/v1/organization/org_mappings/auth_url` : prefix + `/business/v1/organization/org_mappings/auth_url`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary getOrgMappings
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getOrgMappingsUsingGET(params = {} as IgetOrgMappingsUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/org_mappings`.includes(prefix) ? `/business/v1/organization/org_mappings` : prefix + `/business/v1/organization/org_mappings`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary receiveCode
    *@param {string} cookie 
    *@param {string} [code] code
    *@param {string} [state] state
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  receiveCodeUsingGET(params = {} as IreceiveCodeUsingGETParams, options: any = {}): FetchArgs {
    const { code, state,     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/org_mappings/receive_code`.includes(prefix) ? `/business/v1/organization/org_mappings/receive_code` : prefix + `/business/v1/organization/org_mappings/receive_code`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"string" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(state || {}) : (state || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IchangeSuperAdminUsingPOSTParams {
  change_super_admin_request: ChangeSuperAdminRequest, 
  
  
  
}
export interface IcheckSuperAdminEmailUsingGETParams {
  
  
  email: string, 
  
}
export interface IgetBlockStrategiesParams {
  
  
  
  
}
export interface IgetOrgInfoUsingGETParams {
  
  
  
  
}
export interface IupdateBlockStrategiesParams {
  request: UpdateBlockStrategiesRequest, 
  
  
  
}

/**
 *OrganizationControllerApi - fetch parameter creator
 *@export
 */
export const OrganizationControllerApiParamCreator = {
  /**
    *
    *@summary change super admin
    *@param {string} cookie 
    *@param {ChangeSuperAdminRequest} change_super_admin_request changeSuperAdminRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  changeSuperAdminUsingPOST(params = {} as IchangeSuperAdminUsingPOSTParams, options: any = {}): FetchArgs {
    const { change_super_admin_request,     } = params
    // verify required body 'change_super_admin_request' is not null or undefined
    if (change_super_admin_request === null || change_super_admin_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('change_super_admin_request', 'Required parameter change_super_admin_request was null or undefined when calling changeSuperAdminUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/change_super_admin`.includes(prefix) ? `/business/v1/organization/change_super_admin` : prefix + `/business/v1/organization/change_super_admin`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"ChangeSuperAdminRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(change_super_admin_request || {}) : (change_super_admin_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary check super admin email
    *@param {string} cookie 
    *@param {string} email email
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  checkSuperAdminEmailUsingGET(params = {} as IcheckSuperAdminEmailUsingGETParams, options: any = {}): FetchArgs {
    const {  email,    } = params

    // verify required path 'email' is not null or undefined
    if (email === null || email === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('email', 'Required parameter email was null or undefined when calling checkSuperAdminEmailUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/check_super_admin_email/{email}`.includes(prefix) ? `/business/v1/organization/check_super_admin_email/{email}` : prefix + `/business/v1/organization/check_super_admin_email/{email}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"email"}}`, encodeURIComponent(String(email)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the block strategies
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getBlockStrategies(params = {} as IgetBlockStrategiesParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/block_strategies`.includes(prefix) ? `/business/v1/organization/block_strategies` : prefix + `/business/v1/organization/block_strategies`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a organization info
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getOrgInfoUsingGET(params = {} as IgetOrgInfoUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/info`.includes(prefix) ? `/business/v1/organization/info` : prefix + `/business/v1/organization/info`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update the block strategies
    *@param {string} cookie 
    *@param {UpdateBlockStrategiesRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateBlockStrategies(params = {} as IupdateBlockStrategiesParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateBlockStrategies.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/block_strategies`.includes(prefix) ? `/business/v1/organization/block_strategies` : prefix + `/business/v1/organization/block_strategies`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateBlockStrategiesRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetPermissionSetByRoleIdUsingGETParams {
  
  
  role_id: string, 
  
}
export interface IgetPermissionSetByUserIdUsingGETParams {
  
  
  user_id: string, 
  
}
export interface IgetSystemDefaultPermissionSetUsingGETParams {
  
  
  
  
}

/**
 *PermissionSetControllerApi - fetch parameter creator
 *@export
 */
export const PermissionSetControllerApiParamCreator = {
  /**
    *
    *@summary Through role_id Get the relationship data between permission set and permission
    *@param {string} cookie 
    *@param {string} role_id role_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getPermissionSetByRoleIdUsingGET(params = {} as IgetPermissionSetByRoleIdUsingGETParams, options: any = {}): FetchArgs {
    const {  role_id,    } = params

    // verify required path 'role_id' is not null or undefined
    if (role_id === null || role_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('role_id', 'Required parameter role_id was null or undefined when calling getPermissionSetByRoleIdUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/permission_sets/roles/{role_id}`.includes(prefix) ? `/business/v1/organization/permission_sets/roles/{role_id}` : prefix + `/business/v1/organization/permission_sets/roles/{role_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"role_id"}}`, encodeURIComponent(String(role_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Through user_id Get the relationship data between permission set and permission
    *@param {string} cookie 
    *@param {string} user_id user_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getPermissionSetByUserIdUsingGET(params = {} as IgetPermissionSetByUserIdUsingGETParams, options: any = {}): FetchArgs {
    const {  user_id,    } = params

    // verify required path 'user_id' is not null or undefined
    if (user_id === null || user_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_id', 'Required parameter user_id was null or undefined when calling getPermissionSetByUserIdUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/permission_sets/users/{user_id}`.includes(prefix) ? `/business/v1/organization/permission_sets/users/{user_id}` : prefix + `/business/v1/organization/permission_sets/users/{user_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Get the relationship between the system default defined permission set and permissions
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getSystemDefaultPermissionSetUsingGET(params = {} as IgetSystemDefaultPermissionSetUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/permission_sets`.includes(prefix) ? `/business/v1/organization/permission_sets` : prefix + `/business/v1/organization/permission_sets`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateRoleUsingPOSTParams {
  request: RoleCreateRequest, 
  
  
  
}
export interface IgetRoleInfoUsingGETParams {
  
  
  role_id: string, 
  
}
export interface IgetRoleListUsingGETParams {
  
  
  
  
}
export interface IgetUserCountByRoleIdUsingGETParams {
  
  
  role_id: string, 
  
}
export interface IupdateRoleUsingPATCHParams {
  request: RoleUpdateRequest, 
  
  role_id: string, 
  
}

/**
 *RoleControllerApi - fetch parameter creator
 *@export
 */
export const RoleControllerApiParamCreator = {
  /**
    *
    *@summary create role
    *@param {string} cookie 
    *@param {RoleCreateRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createRoleUsingPOST(params = {} as IcreateRoleUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling createRoleUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/role`.includes(prefix) ? `/business/v1/organization/role` : prefix + `/business/v1/organization/role`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"RoleCreateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary get role info
    *@param {string} cookie 
    *@param {string} role_id role_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getRoleInfoUsingGET(params = {} as IgetRoleInfoUsingGETParams, options: any = {}): FetchArgs {
    const {  role_id,    } = params

    // verify required path 'role_id' is not null or undefined
    if (role_id === null || role_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('role_id', 'Required parameter role_id was null or undefined when calling getRoleInfoUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/role/{role_id}`.includes(prefix) ? `/business/v1/organization/role/{role_id}` : prefix + `/business/v1/organization/role/{role_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"role_id"}}`, encodeURIComponent(String(role_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary get role list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getRoleListUsingGET(params = {} as IgetRoleListUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/role`.includes(prefix) ? `/business/v1/organization/role` : prefix + `/business/v1/organization/role`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Through role_id gets the number of user binding roles
    *@param {string} cookie 
    *@param {string} role_id role_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getUserCountByRoleIdUsingGET(params = {} as IgetUserCountByRoleIdUsingGETParams, options: any = {}): FetchArgs {
    const {  role_id,    } = params

    // verify required path 'role_id' is not null or undefined
    if (role_id === null || role_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('role_id', 'Required parameter role_id was null or undefined when calling getUserCountByRoleIdUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/role/{role_id}/user_count`.includes(prefix) ? `/business/v1/organization/role/{role_id}/user_count` : prefix + `/business/v1/organization/role/{role_id}/user_count`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"role_id"}}`, encodeURIComponent(String(role_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update role
    *@param {string} cookie 
    *@param {RoleUpdateRequest} request request
    *@param {string} role_id role_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateRoleUsingPATCH(params = {} as IupdateRoleUsingPATCHParams, options: any = {}): FetchArgs {
    const { request,  role_id,    } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateRoleUsingPATCH.');
    }

    // verify required path 'role_id' is not null or undefined
    if (role_id === null || role_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('role_id', 'Required parameter role_id was null or undefined when calling updateRoleUsingPATCH.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/role/{role_id}`.includes(prefix) ? `/business/v1/organization/role/{role_id}` : prefix + `/business/v1/organization/role/{role_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"role_id"}}`, encodeURIComponent(String(role_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PATCH', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"RoleUpdateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface ImappingUsingPOSTParams {
  request: SocialProfileEditRequest, 
  
  
  
}

/**
 *SocialProfileControllerApi - fetch parameter creator
 *@export
 */
export const SocialProfileControllerApiParamCreator = {
  /**
    *
    *@summary add sf user mapping
    *@param {string} cookie 
    *@param {SocialProfileEditRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  mappingUsingPOST(params = {} as ImappingUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling mappingUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/social_profile/mapping`.includes(prefix) ? `/business/v1/organization/social_profile/mapping` : prefix + `/business/v1/organization/social_profile/mapping`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SocialProfileEditRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IactivateByAcceptedUsingPOSTParams {
  
  ticket: string, 
  
  
}
export interface IactivateByResetPwdUsingPOSTParams {
  ticket_reset_passwd_request: TicketResetPasswdRequest, 
  ticket: string, 
  
  
}
export interface IverifyTicketUsingPOSTParams {
  
  ticket: string, 
  
  
}

/**
 *UserActivationControllerApi - fetch parameter creator
 *@export
 */
export const UserActivationControllerApiParamCreator = {
  /**
    *
    *@summary activate a specific user's account by available ticket
    *@param {string} cookie 
    *@param {string} ticket ticket
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  activateByAcceptedUsingPOST(params = {} as IactivateByAcceptedUsingPOSTParams, options: any = {}): FetchArgs {
    const {   ticket,   } = params


    // verify required query 'ticket' is not null or undefined
    if (ticket === null || ticket === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('ticket', 'Required parameter ticket was null or undefined when calling activateByAcceptedUsingPOST.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/accept_invitation`.includes(prefix) ? `/business/v1/organization/user/accept_invitation` : prefix + `/business/v1/organization/user/accept_invitation`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (ticket !== undefined) {
        localVarQueryParameter.ticket = ticket;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary set a specific user's passwd by available ticket and activate the account
    *@param {string} cookie 
    *@param {string} ticket ticket
    *@param {TicketResetPasswdRequest} ticket_reset_passwd_request ticketResetPasswdRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  activateByResetPwdUsingPOST(params = {} as IactivateByResetPwdUsingPOSTParams, options: any = {}): FetchArgs {
    const { ticket_reset_passwd_request,   ticket,   } = params
    // verify required body 'ticket_reset_passwd_request' is not null or undefined
    if (ticket_reset_passwd_request === null || ticket_reset_passwd_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('ticket_reset_passwd_request', 'Required parameter ticket_reset_passwd_request was null or undefined when calling activateByResetPwdUsingPOST.');
    }


    // verify required query 'ticket' is not null or undefined
    if (ticket === null || ticket === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('ticket', 'Required parameter ticket was null or undefined when calling activateByResetPwdUsingPOST.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/init_passwd`.includes(prefix) ? `/business/v1/organization/user/init_passwd` : prefix + `/business/v1/organization/user/init_passwd`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (ticket !== undefined) {
        localVarQueryParameter.ticket = ticket;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"TicketResetPasswdRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ticket_reset_passwd_request || {}) : (ticket_reset_passwd_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary check if activation link still available
    *@param {string} cookie 
    *@param {string} ticket ticket
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  verifyTicketUsingPOST(params = {} as IverifyTicketUsingPOSTParams, options: any = {}): FetchArgs {
    const {   ticket,   } = params


    // verify required query 'ticket' is not null or undefined
    if (ticket === null || ticket === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('ticket', 'Required parameter ticket was null or undefined when calling verifyTicketUsingPOST.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/check_invite_link`.includes(prefix) ? `/business/v1/organization/user/check_invite_link` : prefix + `/business/v1/organization/user/check_invite_link`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (ticket !== undefined) {
        localVarQueryParameter.ticket = ticket;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IcreateUsingPOSTParams {
  user_create_request: UserCreateRequest, 
  
  
  
}
export interface IdeleteByIdUsingDELETEParams {
  
  
  user_id: string, 
  
}
export interface IfindByIdUsingGETParams {
  
  
  user_id: string, 
  
}
export interface IlistUsingGETParams {
  
  group_by?: string, sort_column?: string, sort_order?: string, filters?: string, num?: number, page?: number, 
  
  
}
export interface IresendByIdUsingPOSTParams {
  
  
  user_id: string, 
  
}
export interface IupdateByIdUsingPUTParams {
  user_update_request: UserUpdateRequest, 
  
  user_id: string, 
  
}

/**
 *UserManagementControllerApi - fetch parameter creator
 *@export
 */
export const UserManagementControllerApiParamCreator = {
  /**
    *
    *@summary create a new user
    *@param {string} cookie 
    *@param {UserCreateRequest} user_create_request userCreateRequest
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  createUsingPOST(params = {} as IcreateUsingPOSTParams, options: any = {}): FetchArgs {
    const { user_create_request,     } = params
    // verify required body 'user_create_request' is not null or undefined
    if (user_create_request === null || user_create_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_create_request', 'Required parameter user_create_request was null or undefined when calling createUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user`.includes(prefix) ? `/business/v1/organization/user` : prefix + `/business/v1/organization/user`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UserCreateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(user_create_request || {}) : (user_create_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary delete a specific user by user_id
    *@param {string} cookie 
    *@param {string} user_id user_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  deleteByIdUsingDELETE(params = {} as IdeleteByIdUsingDELETEParams, options: any = {}): FetchArgs {
    const {  user_id,    } = params

    // verify required path 'user_id' is not null or undefined
    if (user_id === null || user_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_id', 'Required parameter user_id was null or undefined when calling deleteByIdUsingDELETE.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/{user_id}`.includes(prefix) ? `/business/v1/organization/user/{user_id}` : prefix + `/business/v1/organization/user/{user_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'DELETE', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve a specific user by user_id
    *@param {string} cookie 
    *@param {string} user_id user_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  findByIdUsingGET(params = {} as IfindByIdUsingGETParams, options: any = {}): FetchArgs {
    const {  user_id,    } = params

    // verify required path 'user_id' is not null or undefined
    if (user_id === null || user_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_id', 'Required parameter user_id was null or undefined when calling findByIdUsingGET.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/{user_id}`.includes(prefix) ? `/business/v1/organization/user/{user_id}` : prefix + `/business/v1/organization/user/{user_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve the list of users
    *@param {string} cookie 
    *@param {string} [group_by] 
    *@param {string} [sort_column] 
    *@param {string} [sort_order] 
    *@param {string} [filters] 
    *@param {number} [num] 
    *@param {number} [page] 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  listUsingGET(params = {} as IlistUsingGETParams, options: any = {}): FetchArgs {
    const {   group_by, sort_column, sort_order, filters, num, page,   } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/users`.includes(prefix) ? `/business/v1/organization/users` : prefix + `/business/v1/organization/users`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (group_by !== undefined) {
        localVarQueryParameter.group_by = group_by;
    }

    if (sort_column !== undefined) {
        localVarQueryParameter.sort_column = sort_column;
    }

    if (sort_order !== undefined) {
        localVarQueryParameter.sort_order = sort_order;
    }

    if (filters !== undefined) {
        localVarQueryParameter.filters = filters;
    }

    if (num !== undefined) {
        localVarQueryParameter.num = num;
    }

    if (page !== undefined) {
        localVarQueryParameter.page = page;
    }



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary resend activation email to a specific user by user_id
    *@param {string} cookie 
    *@param {string} user_id user_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  resendByIdUsingPOST(params = {} as IresendByIdUsingPOSTParams, options: any = {}): FetchArgs {
    const {  user_id,    } = params

    // verify required path 'user_id' is not null or undefined
    if (user_id === null || user_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_id', 'Required parameter user_id was null or undefined when calling resendByIdUsingPOST.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/{user_id}/resend`.includes(prefix) ? `/business/v1/organization/user/{user_id}/resend` : prefix + `/business/v1/organization/user/{user_id}/resend`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific user by user_id
    *@param {string} cookie 
    *@param {UserUpdateRequest} user_update_request userUpdateRequest
    *@param {string} user_id user_id
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateByIdUsingPUT(params = {} as IupdateByIdUsingPUTParams, options: any = {}): FetchArgs {
    const { user_update_request,  user_id,    } = params
    // verify required body 'user_update_request' is not null or undefined
    if (user_update_request === null || user_update_request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_update_request', 'Required parameter user_update_request was null or undefined when calling updateByIdUsingPUT.');
    }

    // verify required path 'user_id' is not null or undefined
    if (user_id === null || user_id === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('user_id', 'Required parameter user_id was null or undefined when calling updateByIdUsingPUT.');
    }


    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/user/{user_id}`.includes(prefix) ? `/business/v1/organization/user/{user_id}` : prefix + `/business/v1/organization/user/{user_id}`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath
        .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UserUpdateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(user_update_request || {}) : (user_update_request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IgetProfileUsingGETParams {
  
  
  
  
}
export interface IupdateProfileUsingPUTParams {
  self_update_vo: UserSelfUpdateRequest, 
  
  
  
}

/**
 *UserProfileControllerApi - fetch parameter creator
 *@export
 */
export const UserProfileControllerApiParamCreator = {
  /**
    *
    *@summary retrieve a specific tenant user's profile
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getProfileUsingGET(params = {} as IgetProfileUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/profile`.includes(prefix) ? `/business/v1/organization/profile` : prefix + `/business/v1/organization/profile`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary update a specific tenant user's profile
    *@param {string} cookie 
    *@param {UserSelfUpdateRequest} self_update_vo selfUpdateVO
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  updateProfileUsingPUT(params = {} as IupdateProfileUsingPUTParams, options: any = {}): FetchArgs {
    const { self_update_vo,     } = params
    // verify required body 'self_update_vo' is not null or undefined
    if (self_update_vo === null || self_update_vo === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('self_update_vo', 'Required parameter self_update_vo was null or undefined when calling updateProfileUsingPUT.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/organization".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/organization/profile`.includes(prefix) ? `/business/v1/organization/profile` : prefix + `/business/v1/organization/profile`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UserSelfUpdateRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(self_update_vo || {}) : (self_update_vo || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};


